import { Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { Hit } from 'instantsearch.js';
import { FC } from 'react';
import { Highlight } from 'react-instantsearch';
import { SecondaryAttributeData } from './SecondaryAttribute';

const contentSx: SxProps = {
    '&:first-letter': {
        textTransform: 'uppercase',
    },
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    display: '-webkit-box',
    lineClamp: 2,
    lineHeight: '20px',
    maxHeight: 48,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};

interface SubtitleAttributesProps {
    hit: Hit;
    subtitleAttributes: SecondaryAttributeData[];
    subtitleComplement?: string;
}

const SubtitleAttributes: FC<SubtitleAttributesProps> = ({
    hit,
    subtitleAttributes,
    subtitleComplement,
}) => {
    const { baseObjectID } = hit;

    return (
        (subtitleAttributes?.length > 0 || subtitleComplement) && (
            <Typography
                data-test-id={`searchResult-subtitle-${baseObjectID}`}
                sx={contentSx}
                variant="body2"
                gutterBottom
            >
                {subtitleAttributes.map(({ attribute }, index) => (
                    <span key={attribute}>
                        {index > 0 && <span>&nbsp;&#x25cf; </span>}
                        <Highlight attribute={attribute} hit={hit} />
                    </span>
                ))}
                {subtitleComplement &&
                    `${subtitleAttributes.length > 0 ? ' - ' : ''}${subtitleComplement}`}
            </Typography>
        )
    );
};

export default SubtitleAttributes;
